/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { createFileRoute } from '@tanstack/react-router'

import { Route as rootRouteImport } from './routes/__root'
import { Route as PublicRouteImport } from './routes/_public'
import { Route as OnBoardingRouteImport } from './routes/_on-boarding'
import { Route as AuthenticatedRouteImport } from './routes/_authenticated'
import { Route as PublicSignUpRouteImport } from './routes/_public/sign-up'
import { Route as PublicLoginRouteImport } from './routes/_public/login'
import { Route as PublicImpersonateRouteImport } from './routes/_public/impersonate'
import { Route as PublicConfirmEmailRouteImport } from './routes/_public/confirm-email'
import { Route as OnBoardingUpdatePasswordRouteImport } from './routes/_on-boarding/update-password'
import { Route as OnBoardingOnBoardingRouteImport } from './routes/_on-boarding/on-boarding'
import { Route as AuthenticatedResourcesRouteImport } from './routes/_authenticated/resources'
import { Route as AuthenticatedDesignSystemRouteImport } from './routes/_authenticated/design-system'
import { Route as AuthenticatedAnalyticsRouteImport } from './routes/_authenticated/analytics'
import { Route as AuthenticatedSettingsRouteRouteImport } from './routes/_authenticated/settings/route'
import { Route as AuthenticatedCustomizeRouteRouteImport } from './routes/_authenticated/customize/route'
import { Route as AuthenticatedTransactionsIndexRouteImport } from './routes/_authenticated/transactions/index'
import { Route as AuthenticatedSettingsIndexRouteImport } from './routes/_authenticated/settings/index'
import { Route as AuthenticatedNotificationsIndexRouteImport } from './routes/_authenticated/notifications/index'
import { Route as AuthenticatedCustomizeIndexRouteImport } from './routes/_authenticated/customize/index'
import { Route as AuthenticatedTransactionsCaptureRouteImport } from './routes/_authenticated/transactions/capture'
import { Route as AuthenticatedSettingsStaffRouteImport } from './routes/_authenticated/settings/staff'
import { Route as AuthenticatedSettingsSalesPointsRouteImport } from './routes/_authenticated/settings/sales-points'
import { Route as AuthenticatedSettingsDevelopersRouteImport } from './routes/_authenticated/settings/developers'
import { Route as AuthenticatedSettingsBillingsRouteImport } from './routes/_authenticated/settings/billings'
import { Route as AuthenticatedNotificationsNewRouteImport } from './routes/_authenticated/notifications/new'
import { Route as AuthenticatedCustomizeQuickLinksRouteImport } from './routes/_authenticated/customize/quick-links'
import { Route as AuthenticatedCustomersCustomersLayoutRouteImport } from './routes/_authenticated/customers/_customersLayout'
import { Route as AuthenticatedCustomersCustomerIdRouteImport } from './routes/_authenticated/customers/$customerId'
import { Route as AuthenticatedCustomersCustomersLayoutIndexRouteImport } from './routes/_authenticated/customers/_customersLayout.index'
import { Route as AuthenticatedCustomersGroupsCreateRouteImport } from './routes/_authenticated/customers/groups.create'
import { Route as AuthenticatedCustomersGroupsGroupIdRouteImport } from './routes/_authenticated/customers/groups.$groupId'
import { Route as AuthenticatedCustomersCustomersLayoutGroupsRouteImport } from './routes/_authenticated/customers/_customersLayout.groups'

const AuthenticatedCustomersRouteImport = createFileRoute(
  '/_authenticated/customers',
)()

const PublicRoute = PublicRouteImport.update({
  id: '/_public',
  getParentRoute: () => rootRouteImport,
} as any)
const OnBoardingRoute = OnBoardingRouteImport.update({
  id: '/_on-boarding',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthenticatedRoute = AuthenticatedRouteImport.update({
  id: '/_authenticated',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthenticatedCustomersRoute = AuthenticatedCustomersRouteImport.update({
  id: '/customers',
  path: '/customers',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const PublicSignUpRoute = PublicSignUpRouteImport.update({
  id: '/sign-up',
  path: '/sign-up',
  getParentRoute: () => PublicRoute,
} as any)
const PublicLoginRoute = PublicLoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => PublicRoute,
} as any)
const PublicImpersonateRoute = PublicImpersonateRouteImport.update({
  id: '/impersonate',
  path: '/impersonate',
  getParentRoute: () => PublicRoute,
} as any)
const PublicConfirmEmailRoute = PublicConfirmEmailRouteImport.update({
  id: '/confirm-email',
  path: '/confirm-email',
  getParentRoute: () => PublicRoute,
} as any)
const OnBoardingUpdatePasswordRoute =
  OnBoardingUpdatePasswordRouteImport.update({
    id: '/update-password',
    path: '/update-password',
    getParentRoute: () => OnBoardingRoute,
  } as any)
const OnBoardingOnBoardingRoute = OnBoardingOnBoardingRouteImport.update({
  id: '/on-boarding',
  path: '/on-boarding',
  getParentRoute: () => OnBoardingRoute,
} as any)
const AuthenticatedResourcesRoute = AuthenticatedResourcesRouteImport.update({
  id: '/resources',
  path: '/resources',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedDesignSystemRoute =
  AuthenticatedDesignSystemRouteImport.update({
    id: '/design-system',
    path: '/design-system',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedAnalyticsRoute = AuthenticatedAnalyticsRouteImport.update({
  id: '/analytics',
  path: '/analytics',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedSettingsRouteRoute =
  AuthenticatedSettingsRouteRouteImport.update({
    id: '/settings',
    path: '/settings',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedCustomizeRouteRoute =
  AuthenticatedCustomizeRouteRouteImport.update({
    id: '/customize',
    path: '/customize',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedTransactionsIndexRoute =
  AuthenticatedTransactionsIndexRouteImport.update({
    id: '/transactions/',
    path: '/transactions/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedSettingsIndexRoute =
  AuthenticatedSettingsIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedSettingsRouteRoute,
  } as any)
const AuthenticatedNotificationsIndexRoute =
  AuthenticatedNotificationsIndexRouteImport.update({
    id: '/notifications/',
    path: '/notifications/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedCustomizeIndexRoute =
  AuthenticatedCustomizeIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedCustomizeRouteRoute,
  } as any)
const AuthenticatedTransactionsCaptureRoute =
  AuthenticatedTransactionsCaptureRouteImport.update({
    id: '/transactions/capture',
    path: '/transactions/capture',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedSettingsStaffRoute =
  AuthenticatedSettingsStaffRouteImport.update({
    id: '/staff',
    path: '/staff',
    getParentRoute: () => AuthenticatedSettingsRouteRoute,
  } as any)
const AuthenticatedSettingsSalesPointsRoute =
  AuthenticatedSettingsSalesPointsRouteImport.update({
    id: '/sales-points',
    path: '/sales-points',
    getParentRoute: () => AuthenticatedSettingsRouteRoute,
  } as any)
const AuthenticatedSettingsDevelopersRoute =
  AuthenticatedSettingsDevelopersRouteImport.update({
    id: '/developers',
    path: '/developers',
    getParentRoute: () => AuthenticatedSettingsRouteRoute,
  } as any)
const AuthenticatedSettingsBillingsRoute =
  AuthenticatedSettingsBillingsRouteImport.update({
    id: '/billings',
    path: '/billings',
    getParentRoute: () => AuthenticatedSettingsRouteRoute,
  } as any)
const AuthenticatedNotificationsNewRoute =
  AuthenticatedNotificationsNewRouteImport.update({
    id: '/notifications/new',
    path: '/notifications/new',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedCustomizeQuickLinksRoute =
  AuthenticatedCustomizeQuickLinksRouteImport.update({
    id: '/quick-links',
    path: '/quick-links',
    getParentRoute: () => AuthenticatedCustomizeRouteRoute,
  } as any)
const AuthenticatedCustomersCustomersLayoutRoute =
  AuthenticatedCustomersCustomersLayoutRouteImport.update({
    id: '/_customersLayout',
    getParentRoute: () => AuthenticatedCustomersRoute,
  } as any)
const AuthenticatedCustomersCustomerIdRoute =
  AuthenticatedCustomersCustomerIdRouteImport.update({
    id: '/customers/$customerId',
    path: '/customers/$customerId',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedCustomersCustomersLayoutIndexRoute =
  AuthenticatedCustomersCustomersLayoutIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedCustomersCustomersLayoutRoute,
  } as any)
const AuthenticatedCustomersGroupsCreateRoute =
  AuthenticatedCustomersGroupsCreateRouteImport.update({
    id: '/groups/create',
    path: '/groups/create',
    getParentRoute: () => AuthenticatedCustomersRoute,
  } as any)
const AuthenticatedCustomersGroupsGroupIdRoute =
  AuthenticatedCustomersGroupsGroupIdRouteImport.update({
    id: '/groups/$groupId',
    path: '/groups/$groupId',
    getParentRoute: () => AuthenticatedCustomersRoute,
  } as any)
const AuthenticatedCustomersCustomersLayoutGroupsRoute =
  AuthenticatedCustomersCustomersLayoutGroupsRouteImport.update({
    id: '/groups',
    path: '/groups',
    getParentRoute: () => AuthenticatedCustomersCustomersLayoutRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/customize': typeof AuthenticatedCustomizeRouteRouteWithChildren
  '/settings': typeof AuthenticatedSettingsRouteRouteWithChildren
  '/analytics': typeof AuthenticatedAnalyticsRoute
  '/design-system': typeof AuthenticatedDesignSystemRoute
  '/resources': typeof AuthenticatedResourcesRoute
  '/on-boarding': typeof OnBoardingOnBoardingRoute
  '/update-password': typeof OnBoardingUpdatePasswordRoute
  '/confirm-email': typeof PublicConfirmEmailRoute
  '/impersonate': typeof PublicImpersonateRoute
  '/login': typeof PublicLoginRoute
  '/sign-up': typeof PublicSignUpRoute
  '/customers/$customerId': typeof AuthenticatedCustomersCustomerIdRoute
  '/customers': typeof AuthenticatedCustomersCustomersLayoutRouteWithChildren
  '/customize/quick-links': typeof AuthenticatedCustomizeQuickLinksRoute
  '/notifications/new': typeof AuthenticatedNotificationsNewRoute
  '/settings/billings': typeof AuthenticatedSettingsBillingsRoute
  '/settings/developers': typeof AuthenticatedSettingsDevelopersRoute
  '/settings/sales-points': typeof AuthenticatedSettingsSalesPointsRoute
  '/settings/staff': typeof AuthenticatedSettingsStaffRoute
  '/transactions/capture': typeof AuthenticatedTransactionsCaptureRoute
  '/customize/': typeof AuthenticatedCustomizeIndexRoute
  '/notifications': typeof AuthenticatedNotificationsIndexRoute
  '/settings/': typeof AuthenticatedSettingsIndexRoute
  '/transactions': typeof AuthenticatedTransactionsIndexRoute
  '/customers/groups': typeof AuthenticatedCustomersCustomersLayoutGroupsRoute
  '/customers/groups/$groupId': typeof AuthenticatedCustomersGroupsGroupIdRoute
  '/customers/groups/create': typeof AuthenticatedCustomersGroupsCreateRoute
  '/customers/': typeof AuthenticatedCustomersCustomersLayoutIndexRoute
}
export interface FileRoutesByTo {
  '/analytics': typeof AuthenticatedAnalyticsRoute
  '/design-system': typeof AuthenticatedDesignSystemRoute
  '/resources': typeof AuthenticatedResourcesRoute
  '/on-boarding': typeof OnBoardingOnBoardingRoute
  '/update-password': typeof OnBoardingUpdatePasswordRoute
  '/confirm-email': typeof PublicConfirmEmailRoute
  '/impersonate': typeof PublicImpersonateRoute
  '/login': typeof PublicLoginRoute
  '/sign-up': typeof PublicSignUpRoute
  '/customers/$customerId': typeof AuthenticatedCustomersCustomerIdRoute
  '/customers': typeof AuthenticatedCustomersCustomersLayoutIndexRoute
  '/customize/quick-links': typeof AuthenticatedCustomizeQuickLinksRoute
  '/notifications/new': typeof AuthenticatedNotificationsNewRoute
  '/settings/billings': typeof AuthenticatedSettingsBillingsRoute
  '/settings/developers': typeof AuthenticatedSettingsDevelopersRoute
  '/settings/sales-points': typeof AuthenticatedSettingsSalesPointsRoute
  '/settings/staff': typeof AuthenticatedSettingsStaffRoute
  '/transactions/capture': typeof AuthenticatedTransactionsCaptureRoute
  '/customize': typeof AuthenticatedCustomizeIndexRoute
  '/notifications': typeof AuthenticatedNotificationsIndexRoute
  '/settings': typeof AuthenticatedSettingsIndexRoute
  '/transactions': typeof AuthenticatedTransactionsIndexRoute
  '/customers/groups': typeof AuthenticatedCustomersCustomersLayoutGroupsRoute
  '/customers/groups/$groupId': typeof AuthenticatedCustomersGroupsGroupIdRoute
  '/customers/groups/create': typeof AuthenticatedCustomersGroupsCreateRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/_authenticated': typeof AuthenticatedRouteWithChildren
  '/_on-boarding': typeof OnBoardingRouteWithChildren
  '/_public': typeof PublicRouteWithChildren
  '/_authenticated/customize': typeof AuthenticatedCustomizeRouteRouteWithChildren
  '/_authenticated/settings': typeof AuthenticatedSettingsRouteRouteWithChildren
  '/_authenticated/analytics': typeof AuthenticatedAnalyticsRoute
  '/_authenticated/design-system': typeof AuthenticatedDesignSystemRoute
  '/_authenticated/resources': typeof AuthenticatedResourcesRoute
  '/_on-boarding/on-boarding': typeof OnBoardingOnBoardingRoute
  '/_on-boarding/update-password': typeof OnBoardingUpdatePasswordRoute
  '/_public/confirm-email': typeof PublicConfirmEmailRoute
  '/_public/impersonate': typeof PublicImpersonateRoute
  '/_public/login': typeof PublicLoginRoute
  '/_public/sign-up': typeof PublicSignUpRoute
  '/_authenticated/customers/$customerId': typeof AuthenticatedCustomersCustomerIdRoute
  '/_authenticated/customers': typeof AuthenticatedCustomersRouteWithChildren
  '/_authenticated/customers/_customersLayout': typeof AuthenticatedCustomersCustomersLayoutRouteWithChildren
  '/_authenticated/customize/quick-links': typeof AuthenticatedCustomizeQuickLinksRoute
  '/_authenticated/notifications/new': typeof AuthenticatedNotificationsNewRoute
  '/_authenticated/settings/billings': typeof AuthenticatedSettingsBillingsRoute
  '/_authenticated/settings/developers': typeof AuthenticatedSettingsDevelopersRoute
  '/_authenticated/settings/sales-points': typeof AuthenticatedSettingsSalesPointsRoute
  '/_authenticated/settings/staff': typeof AuthenticatedSettingsStaffRoute
  '/_authenticated/transactions/capture': typeof AuthenticatedTransactionsCaptureRoute
  '/_authenticated/customize/': typeof AuthenticatedCustomizeIndexRoute
  '/_authenticated/notifications/': typeof AuthenticatedNotificationsIndexRoute
  '/_authenticated/settings/': typeof AuthenticatedSettingsIndexRoute
  '/_authenticated/transactions/': typeof AuthenticatedTransactionsIndexRoute
  '/_authenticated/customers/_customersLayout/groups': typeof AuthenticatedCustomersCustomersLayoutGroupsRoute
  '/_authenticated/customers/groups/$groupId': typeof AuthenticatedCustomersGroupsGroupIdRoute
  '/_authenticated/customers/groups/create': typeof AuthenticatedCustomersGroupsCreateRoute
  '/_authenticated/customers/_customersLayout/': typeof AuthenticatedCustomersCustomersLayoutIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/customize'
    | '/settings'
    | '/analytics'
    | '/design-system'
    | '/resources'
    | '/on-boarding'
    | '/update-password'
    | '/confirm-email'
    | '/impersonate'
    | '/login'
    | '/sign-up'
    | '/customers/$customerId'
    | '/customers'
    | '/customize/quick-links'
    | '/notifications/new'
    | '/settings/billings'
    | '/settings/developers'
    | '/settings/sales-points'
    | '/settings/staff'
    | '/transactions/capture'
    | '/customize/'
    | '/notifications'
    | '/settings/'
    | '/transactions'
    | '/customers/groups'
    | '/customers/groups/$groupId'
    | '/customers/groups/create'
    | '/customers/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/analytics'
    | '/design-system'
    | '/resources'
    | '/on-boarding'
    | '/update-password'
    | '/confirm-email'
    | '/impersonate'
    | '/login'
    | '/sign-up'
    | '/customers/$customerId'
    | '/customers'
    | '/customize/quick-links'
    | '/notifications/new'
    | '/settings/billings'
    | '/settings/developers'
    | '/settings/sales-points'
    | '/settings/staff'
    | '/transactions/capture'
    | '/customize'
    | '/notifications'
    | '/settings'
    | '/transactions'
    | '/customers/groups'
    | '/customers/groups/$groupId'
    | '/customers/groups/create'
  id:
    | '__root__'
    | '/_authenticated'
    | '/_on-boarding'
    | '/_public'
    | '/_authenticated/customize'
    | '/_authenticated/settings'
    | '/_authenticated/analytics'
    | '/_authenticated/design-system'
    | '/_authenticated/resources'
    | '/_on-boarding/on-boarding'
    | '/_on-boarding/update-password'
    | '/_public/confirm-email'
    | '/_public/impersonate'
    | '/_public/login'
    | '/_public/sign-up'
    | '/_authenticated/customers/$customerId'
    | '/_authenticated/customers'
    | '/_authenticated/customers/_customersLayout'
    | '/_authenticated/customize/quick-links'
    | '/_authenticated/notifications/new'
    | '/_authenticated/settings/billings'
    | '/_authenticated/settings/developers'
    | '/_authenticated/settings/sales-points'
    | '/_authenticated/settings/staff'
    | '/_authenticated/transactions/capture'
    | '/_authenticated/customize/'
    | '/_authenticated/notifications/'
    | '/_authenticated/settings/'
    | '/_authenticated/transactions/'
    | '/_authenticated/customers/_customersLayout/groups'
    | '/_authenticated/customers/groups/$groupId'
    | '/_authenticated/customers/groups/create'
    | '/_authenticated/customers/_customersLayout/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  AuthenticatedRoute: typeof AuthenticatedRouteWithChildren
  OnBoardingRoute: typeof OnBoardingRouteWithChildren
  PublicRoute: typeof PublicRouteWithChildren
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/_public': {
      id: '/_public'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof PublicRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_on-boarding': {
      id: '/_on-boarding'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof OnBoardingRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authenticated': {
      id: '/_authenticated'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof AuthenticatedRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authenticated/customers': {
      id: '/_authenticated/customers'
      path: '/customers'
      fullPath: '/customers'
      preLoaderRoute: typeof AuthenticatedCustomersRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_public/sign-up': {
      id: '/_public/sign-up'
      path: '/sign-up'
      fullPath: '/sign-up'
      preLoaderRoute: typeof PublicSignUpRouteImport
      parentRoute: typeof PublicRoute
    }
    '/_public/login': {
      id: '/_public/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof PublicLoginRouteImport
      parentRoute: typeof PublicRoute
    }
    '/_public/impersonate': {
      id: '/_public/impersonate'
      path: '/impersonate'
      fullPath: '/impersonate'
      preLoaderRoute: typeof PublicImpersonateRouteImport
      parentRoute: typeof PublicRoute
    }
    '/_public/confirm-email': {
      id: '/_public/confirm-email'
      path: '/confirm-email'
      fullPath: '/confirm-email'
      preLoaderRoute: typeof PublicConfirmEmailRouteImport
      parentRoute: typeof PublicRoute
    }
    '/_on-boarding/update-password': {
      id: '/_on-boarding/update-password'
      path: '/update-password'
      fullPath: '/update-password'
      preLoaderRoute: typeof OnBoardingUpdatePasswordRouteImport
      parentRoute: typeof OnBoardingRoute
    }
    '/_on-boarding/on-boarding': {
      id: '/_on-boarding/on-boarding'
      path: '/on-boarding'
      fullPath: '/on-boarding'
      preLoaderRoute: typeof OnBoardingOnBoardingRouteImport
      parentRoute: typeof OnBoardingRoute
    }
    '/_authenticated/resources': {
      id: '/_authenticated/resources'
      path: '/resources'
      fullPath: '/resources'
      preLoaderRoute: typeof AuthenticatedResourcesRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/design-system': {
      id: '/_authenticated/design-system'
      path: '/design-system'
      fullPath: '/design-system'
      preLoaderRoute: typeof AuthenticatedDesignSystemRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/analytics': {
      id: '/_authenticated/analytics'
      path: '/analytics'
      fullPath: '/analytics'
      preLoaderRoute: typeof AuthenticatedAnalyticsRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/settings': {
      id: '/_authenticated/settings'
      path: '/settings'
      fullPath: '/settings'
      preLoaderRoute: typeof AuthenticatedSettingsRouteRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/customize': {
      id: '/_authenticated/customize'
      path: '/customize'
      fullPath: '/customize'
      preLoaderRoute: typeof AuthenticatedCustomizeRouteRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/transactions/': {
      id: '/_authenticated/transactions/'
      path: '/transactions'
      fullPath: '/transactions'
      preLoaderRoute: typeof AuthenticatedTransactionsIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/settings/': {
      id: '/_authenticated/settings/'
      path: '/'
      fullPath: '/settings/'
      preLoaderRoute: typeof AuthenticatedSettingsIndexRouteImport
      parentRoute: typeof AuthenticatedSettingsRouteRoute
    }
    '/_authenticated/notifications/': {
      id: '/_authenticated/notifications/'
      path: '/notifications'
      fullPath: '/notifications'
      preLoaderRoute: typeof AuthenticatedNotificationsIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/customize/': {
      id: '/_authenticated/customize/'
      path: '/'
      fullPath: '/customize/'
      preLoaderRoute: typeof AuthenticatedCustomizeIndexRouteImport
      parentRoute: typeof AuthenticatedCustomizeRouteRoute
    }
    '/_authenticated/transactions/capture': {
      id: '/_authenticated/transactions/capture'
      path: '/transactions/capture'
      fullPath: '/transactions/capture'
      preLoaderRoute: typeof AuthenticatedTransactionsCaptureRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/settings/staff': {
      id: '/_authenticated/settings/staff'
      path: '/staff'
      fullPath: '/settings/staff'
      preLoaderRoute: typeof AuthenticatedSettingsStaffRouteImport
      parentRoute: typeof AuthenticatedSettingsRouteRoute
    }
    '/_authenticated/settings/sales-points': {
      id: '/_authenticated/settings/sales-points'
      path: '/sales-points'
      fullPath: '/settings/sales-points'
      preLoaderRoute: typeof AuthenticatedSettingsSalesPointsRouteImport
      parentRoute: typeof AuthenticatedSettingsRouteRoute
    }
    '/_authenticated/settings/developers': {
      id: '/_authenticated/settings/developers'
      path: '/developers'
      fullPath: '/settings/developers'
      preLoaderRoute: typeof AuthenticatedSettingsDevelopersRouteImport
      parentRoute: typeof AuthenticatedSettingsRouteRoute
    }
    '/_authenticated/settings/billings': {
      id: '/_authenticated/settings/billings'
      path: '/billings'
      fullPath: '/settings/billings'
      preLoaderRoute: typeof AuthenticatedSettingsBillingsRouteImport
      parentRoute: typeof AuthenticatedSettingsRouteRoute
    }
    '/_authenticated/notifications/new': {
      id: '/_authenticated/notifications/new'
      path: '/notifications/new'
      fullPath: '/notifications/new'
      preLoaderRoute: typeof AuthenticatedNotificationsNewRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/customize/quick-links': {
      id: '/_authenticated/customize/quick-links'
      path: '/quick-links'
      fullPath: '/customize/quick-links'
      preLoaderRoute: typeof AuthenticatedCustomizeQuickLinksRouteImport
      parentRoute: typeof AuthenticatedCustomizeRouteRoute
    }
    '/_authenticated/customers/_customersLayout': {
      id: '/_authenticated/customers/_customersLayout'
      path: '/customers'
      fullPath: '/customers'
      preLoaderRoute: typeof AuthenticatedCustomersCustomersLayoutRouteImport
      parentRoute: typeof AuthenticatedCustomersRoute
    }
    '/_authenticated/customers/$customerId': {
      id: '/_authenticated/customers/$customerId'
      path: '/customers/$customerId'
      fullPath: '/customers/$customerId'
      preLoaderRoute: typeof AuthenticatedCustomersCustomerIdRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/customers/_customersLayout/': {
      id: '/_authenticated/customers/_customersLayout/'
      path: '/'
      fullPath: '/customers/'
      preLoaderRoute: typeof AuthenticatedCustomersCustomersLayoutIndexRouteImport
      parentRoute: typeof AuthenticatedCustomersCustomersLayoutRoute
    }
    '/_authenticated/customers/groups/create': {
      id: '/_authenticated/customers/groups/create'
      path: '/groups/create'
      fullPath: '/customers/groups/create'
      preLoaderRoute: typeof AuthenticatedCustomersGroupsCreateRouteImport
      parentRoute: typeof AuthenticatedCustomersRoute
    }
    '/_authenticated/customers/groups/$groupId': {
      id: '/_authenticated/customers/groups/$groupId'
      path: '/groups/$groupId'
      fullPath: '/customers/groups/$groupId'
      preLoaderRoute: typeof AuthenticatedCustomersGroupsGroupIdRouteImport
      parentRoute: typeof AuthenticatedCustomersRoute
    }
    '/_authenticated/customers/_customersLayout/groups': {
      id: '/_authenticated/customers/_customersLayout/groups'
      path: '/groups'
      fullPath: '/customers/groups'
      preLoaderRoute: typeof AuthenticatedCustomersCustomersLayoutGroupsRouteImport
      parentRoute: typeof AuthenticatedCustomersCustomersLayoutRoute
    }
  }
}

interface AuthenticatedCustomizeRouteRouteChildren {
  AuthenticatedCustomizeQuickLinksRoute: typeof AuthenticatedCustomizeQuickLinksRoute
  AuthenticatedCustomizeIndexRoute: typeof AuthenticatedCustomizeIndexRoute
}

const AuthenticatedCustomizeRouteRouteChildren: AuthenticatedCustomizeRouteRouteChildren =
  {
    AuthenticatedCustomizeQuickLinksRoute:
      AuthenticatedCustomizeQuickLinksRoute,
    AuthenticatedCustomizeIndexRoute: AuthenticatedCustomizeIndexRoute,
  }

const AuthenticatedCustomizeRouteRouteWithChildren =
  AuthenticatedCustomizeRouteRoute._addFileChildren(
    AuthenticatedCustomizeRouteRouteChildren,
  )

interface AuthenticatedSettingsRouteRouteChildren {
  AuthenticatedSettingsBillingsRoute: typeof AuthenticatedSettingsBillingsRoute
  AuthenticatedSettingsDevelopersRoute: typeof AuthenticatedSettingsDevelopersRoute
  AuthenticatedSettingsSalesPointsRoute: typeof AuthenticatedSettingsSalesPointsRoute
  AuthenticatedSettingsStaffRoute: typeof AuthenticatedSettingsStaffRoute
  AuthenticatedSettingsIndexRoute: typeof AuthenticatedSettingsIndexRoute
}

const AuthenticatedSettingsRouteRouteChildren: AuthenticatedSettingsRouteRouteChildren =
  {
    AuthenticatedSettingsBillingsRoute: AuthenticatedSettingsBillingsRoute,
    AuthenticatedSettingsDevelopersRoute: AuthenticatedSettingsDevelopersRoute,
    AuthenticatedSettingsSalesPointsRoute:
      AuthenticatedSettingsSalesPointsRoute,
    AuthenticatedSettingsStaffRoute: AuthenticatedSettingsStaffRoute,
    AuthenticatedSettingsIndexRoute: AuthenticatedSettingsIndexRoute,
  }

const AuthenticatedSettingsRouteRouteWithChildren =
  AuthenticatedSettingsRouteRoute._addFileChildren(
    AuthenticatedSettingsRouteRouteChildren,
  )

interface AuthenticatedCustomersCustomersLayoutRouteChildren {
  AuthenticatedCustomersCustomersLayoutGroupsRoute: typeof AuthenticatedCustomersCustomersLayoutGroupsRoute
  AuthenticatedCustomersCustomersLayoutIndexRoute: typeof AuthenticatedCustomersCustomersLayoutIndexRoute
}

const AuthenticatedCustomersCustomersLayoutRouteChildren: AuthenticatedCustomersCustomersLayoutRouteChildren =
  {
    AuthenticatedCustomersCustomersLayoutGroupsRoute:
      AuthenticatedCustomersCustomersLayoutGroupsRoute,
    AuthenticatedCustomersCustomersLayoutIndexRoute:
      AuthenticatedCustomersCustomersLayoutIndexRoute,
  }

const AuthenticatedCustomersCustomersLayoutRouteWithChildren =
  AuthenticatedCustomersCustomersLayoutRoute._addFileChildren(
    AuthenticatedCustomersCustomersLayoutRouteChildren,
  )

interface AuthenticatedCustomersRouteChildren {
  AuthenticatedCustomersCustomersLayoutRoute: typeof AuthenticatedCustomersCustomersLayoutRouteWithChildren
  AuthenticatedCustomersGroupsGroupIdRoute: typeof AuthenticatedCustomersGroupsGroupIdRoute
  AuthenticatedCustomersGroupsCreateRoute: typeof AuthenticatedCustomersGroupsCreateRoute
}

const AuthenticatedCustomersRouteChildren: AuthenticatedCustomersRouteChildren =
  {
    AuthenticatedCustomersCustomersLayoutRoute:
      AuthenticatedCustomersCustomersLayoutRouteWithChildren,
    AuthenticatedCustomersGroupsGroupIdRoute:
      AuthenticatedCustomersGroupsGroupIdRoute,
    AuthenticatedCustomersGroupsCreateRoute:
      AuthenticatedCustomersGroupsCreateRoute,
  }

const AuthenticatedCustomersRouteWithChildren =
  AuthenticatedCustomersRoute._addFileChildren(
    AuthenticatedCustomersRouteChildren,
  )

interface AuthenticatedRouteChildren {
  AuthenticatedCustomizeRouteRoute: typeof AuthenticatedCustomizeRouteRouteWithChildren
  AuthenticatedSettingsRouteRoute: typeof AuthenticatedSettingsRouteRouteWithChildren
  AuthenticatedAnalyticsRoute: typeof AuthenticatedAnalyticsRoute
  AuthenticatedDesignSystemRoute: typeof AuthenticatedDesignSystemRoute
  AuthenticatedResourcesRoute: typeof AuthenticatedResourcesRoute
  AuthenticatedCustomersCustomerIdRoute: typeof AuthenticatedCustomersCustomerIdRoute
  AuthenticatedCustomersRoute: typeof AuthenticatedCustomersRouteWithChildren
  AuthenticatedNotificationsNewRoute: typeof AuthenticatedNotificationsNewRoute
  AuthenticatedTransactionsCaptureRoute: typeof AuthenticatedTransactionsCaptureRoute
  AuthenticatedNotificationsIndexRoute: typeof AuthenticatedNotificationsIndexRoute
  AuthenticatedTransactionsIndexRoute: typeof AuthenticatedTransactionsIndexRoute
}

const AuthenticatedRouteChildren: AuthenticatedRouteChildren = {
  AuthenticatedCustomizeRouteRoute:
    AuthenticatedCustomizeRouteRouteWithChildren,
  AuthenticatedSettingsRouteRoute: AuthenticatedSettingsRouteRouteWithChildren,
  AuthenticatedAnalyticsRoute: AuthenticatedAnalyticsRoute,
  AuthenticatedDesignSystemRoute: AuthenticatedDesignSystemRoute,
  AuthenticatedResourcesRoute: AuthenticatedResourcesRoute,
  AuthenticatedCustomersCustomerIdRoute: AuthenticatedCustomersCustomerIdRoute,
  AuthenticatedCustomersRoute: AuthenticatedCustomersRouteWithChildren,
  AuthenticatedNotificationsNewRoute: AuthenticatedNotificationsNewRoute,
  AuthenticatedTransactionsCaptureRoute: AuthenticatedTransactionsCaptureRoute,
  AuthenticatedNotificationsIndexRoute: AuthenticatedNotificationsIndexRoute,
  AuthenticatedTransactionsIndexRoute: AuthenticatedTransactionsIndexRoute,
}

const AuthenticatedRouteWithChildren = AuthenticatedRoute._addFileChildren(
  AuthenticatedRouteChildren,
)

interface OnBoardingRouteChildren {
  OnBoardingOnBoardingRoute: typeof OnBoardingOnBoardingRoute
  OnBoardingUpdatePasswordRoute: typeof OnBoardingUpdatePasswordRoute
}

const OnBoardingRouteChildren: OnBoardingRouteChildren = {
  OnBoardingOnBoardingRoute: OnBoardingOnBoardingRoute,
  OnBoardingUpdatePasswordRoute: OnBoardingUpdatePasswordRoute,
}

const OnBoardingRouteWithChildren = OnBoardingRoute._addFileChildren(
  OnBoardingRouteChildren,
)

interface PublicRouteChildren {
  PublicConfirmEmailRoute: typeof PublicConfirmEmailRoute
  PublicImpersonateRoute: typeof PublicImpersonateRoute
  PublicLoginRoute: typeof PublicLoginRoute
  PublicSignUpRoute: typeof PublicSignUpRoute
}

const PublicRouteChildren: PublicRouteChildren = {
  PublicConfirmEmailRoute: PublicConfirmEmailRoute,
  PublicImpersonateRoute: PublicImpersonateRoute,
  PublicLoginRoute: PublicLoginRoute,
  PublicSignUpRoute: PublicSignUpRoute,
}

const PublicRouteWithChildren =
  PublicRoute._addFileChildren(PublicRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  AuthenticatedRoute: AuthenticatedRouteWithChildren,
  OnBoardingRoute: OnBoardingRouteWithChildren,
  PublicRoute: PublicRouteWithChildren,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
